import { environment } from "src/environments/environment";
import { KeyValueId } from "src/service/local.service";
import { ArabicFont, BengaliFont, ChineseFont, EnglishFont, EnglishFont_Arial, EnglishFont_Courier, EnglishFont_JetBrainsMono, EnglishFont_Tahoma, EnglishFont_Verdana, GujaratiFont, HindiFont, JapaneseFont, KoreanFont, MalayalamFont, MarathiFont, OdiaFont, PunjabiFont, RussianFont, SinhalaFont, TamilFont, TeluguFont, ThaiFont } from "./fonts";

export enum ReplaceFontType {
    None = 0,
    Url = 1,
    FontPath = 2,
    FontName = 3
}

export const ReplaceFonts = (content: string, replaceFontType: ReplaceFontType): string => {
    if (content.indexOf('fixed-direct') > -1) {
        replaceFontType = ReplaceFontType.FontName;
    }

    const fontNames: KeyValueId[] = [
        { key: "EnglishFont", value: "english" } as KeyValueId,
        { key: "TamilFont", value: "tamil" } as KeyValueId,
        { key: "ArabicFont", value: "arabic" } as KeyValueId,
        { key: "BengaliFont", value: "bengali" } as KeyValueId,
        { key: "GermanFont", value: "german" } as KeyValueId,
        { key: "SpanishFont", value: "spanish" } as KeyValueId,
        { key: "FrenchFont", value: "french" } as KeyValueId,
        { key: "GujaratiFont", value: "gujarati" } as KeyValueId,
        { key: "HindiFont", value: "hindi" } as KeyValueId,
        { key: "JapaneseFont", value: "japanese" } as KeyValueId,
        { key: "KannadaFont", value: "kannada" } as KeyValueId,
        { key: "KoreanFont", value: "korean" } as KeyValueId,
        { key: "MalayalamFont", value: "malayalam" } as KeyValueId,
        { key: "MarathiFont", value: "marathi" } as KeyValueId,
        { key: "OdiaFont", value: "odia" } as KeyValueId,
        { key: "PunjabiFont", value: "punjabi" } as KeyValueId,
        { key: "RussianFont", value: "russian" } as KeyValueId,
        { key: "SinhalaFont", value: "sinhala" } as KeyValueId,
        { key: "TeluguFont", value: "telugu" } as KeyValueId,
        { key: "ThaiFont", value: "thai" } as KeyValueId,
        { key: "ChineseFont", value: "chinese" } as KeyValueId,
        { key: "EnglishFont_Courier", value: "english_courier" } as KeyValueId,
        { key: "GermanFont_Courier", value: "english_courier" } as KeyValueId,
        { key: "SpanishFont_Courier", value: "english_courier" } as KeyValueId,
        { key: "FrenchFont_Courier", value: "english_courier" } as KeyValueId,
        { key: "EnglishFont_JetBrainsMono", value: "english_jetbrainsmono" } as KeyValueId,
        { key: "GermanFont_JetBrainsMono", value: "english_jetbrainsmono" } as KeyValueId,
        { key: "SpanishFont_JetBrainsMono", value: "english_jetbrainsmono" } as KeyValueId,
        { key: "FrenchFont_JetBrainsMono", value: "english_jetbrainsmono" } as KeyValueId,
        { key: "EnglishFont_Arial", value: "english_arial" } as KeyValueId,
        { key: "GermanFont_Arial", value: "english_arial" } as KeyValueId,
        { key: "SpanishFont_Arial", value: "english_arial" } as KeyValueId,
        { key: "FrenchFont_Arial", value: "english_arial" } as KeyValueId,
        { key: "EnglishFont_Tahoma", value: "english_tahoma" } as KeyValueId,
        { key: "GermanFont_Tahoma", value: "english_tahoma" } as KeyValueId,
        { key: "SpanishFont_Tahoma", value: "english_tahoma" } as KeyValueId,
        { key: "FrenchFont_Tahoma", value: "english_tahoma" } as KeyValueId,
        { key: "EnglishFont_Verdana", value: "english_verdana" } as KeyValueId,
        { key: "GermanFont_Verdana", value: "english_verdana" } as KeyValueId,
        { key: "SpanishFont_Verdana", value: "english_verdana" } as KeyValueId,
        { key: "FrenchFont_Verdana", value: "english_verdana" } as KeyValueId
    ];

    switch (replaceFontType) {
        case ReplaceFontType.FontPath: {
            let fontPaths = ['{{font_path}}'];
            fontNames.forEach(fontName => {
                fontPaths.forEach(fontPath => {
                    const fontUrl: string = "url('" + fontPath + fontName.value + ".woff')";
                    //const tempContents = tempContent.split("font-family: " + fontName.key + ";");
                    content = ReplaceFontsContent(content, fontName.key, fontUrl);
                });
            });
        } break;
        case ReplaceFontType.Url: {
            let appUrls = [environment.url.app, environment.url.app_without_www];

            fontNames.forEach(fontName => {
                appUrls.forEach(appUrl => {
                    const appUrlTemp = appUrl.endsWith('/') ? appUrl.slice(0, -1) : appUrl;

                    const fontUrlWithSlash: string = "url('" + appUrlTemp + "/assets/scss/" + fontName.value + ".woff')";
                    content = ReplaceFontsContent(content, fontName.key, fontUrlWithSlash);

                    const fontUrl: string = "url('" + appUrlTemp + "assets/scss/" + fontName.value + ".woff')";
                    //const tempContents = tempContent.split("font-family: " + fontName.key + ";");
                    content = ReplaceFontsContent(content, fontName.key, fontUrl);
                });
            });
        } break;
        case ReplaceFontType.FontName: {
            fontNames.forEach(fontName => {
                const fontUrl: string = "url('" + fontName.value + ".woff')";
                content = ReplaceFontsContent(content, fontName.key, fontUrl);
            });
        } break;
        default: {
            fontNames.forEach(fontName => {
                const fontNameKey: string = "##" + fontName.key + "##";
                content = ReplaceFontsContent(content, fontName.key, fontNameKey);
            });
        } break;
    }
    return content;
}

const ReplaceFontsContent = (content: string, fontName: string, toReplace: string): string => {
    if (content.indexOf(toReplace) > -1) {
        let fontUrlLocal: string = '';
        switch (fontName) {
            case 'EnglishFont':
            case 'GermanFont':
            case 'SpanishFont':
            case 'FrenchFont': {
                fontUrlLocal = "url('" + EnglishFont + "')";
            } break;
            case 'TamilFont': {
                fontUrlLocal = "url('" + TamilFont + "')";
            } break;
            case 'ArabicFont': {
                fontUrlLocal = "url('" + ArabicFont + "')";
            } break;
            case 'BengaliFont': {
                fontUrlLocal = "url('" + BengaliFont + "')";
            } break;
            case 'GujaratiFont': {
                fontUrlLocal = "url('" + GujaratiFont + "')";
            } break;
            case 'HindiFont': {
                fontUrlLocal = "url('" + HindiFont + "')";
            } break;
            case 'JapaneseFont': {
                fontUrlLocal = "url('" + EnglishFont + "')";
            } break;
            case 'KannadaFont': {
                fontUrlLocal = "url('" + JapaneseFont + "')";
            } break;
            case 'KoreanFont': {
                fontUrlLocal = "url('" + KoreanFont + "')";
            } break;
            case 'MalayalamFont': {
                fontUrlLocal = "url('" + MalayalamFont + "')";
            } break;
            case 'MarathiFont': {
                fontUrlLocal = "url('" + MarathiFont + "')";
            } break;
            case 'OdiaFont': {
                fontUrlLocal = "url('" + OdiaFont + "')";
            } break;
            case 'PunjabiFont': {
                fontUrlLocal = "url('" + PunjabiFont + "')";
            } break;
            case 'RussianFont': {
                fontUrlLocal = "url('" + RussianFont + "')";
            } break;
            case 'SinhalaFont': {
                fontUrlLocal = "url('" + SinhalaFont + "')";
            } break;
            case 'TeluguFont': {
                fontUrlLocal = "url('" + TeluguFont + "')";
            } break;
            case 'ThaiFont': {
                fontUrlLocal = "url('" + ThaiFont + "')";
            } break;
            case 'ChineseFont': {
                fontUrlLocal = "url('" + ChineseFont + "')";
            } break;
            case 'EnglishFont_Courier':
            case 'GermanFont_Courier':
            case 'SpanishFont_Courier':
            case 'FrenchFont_Courier': {
                fontUrlLocal = "url('" + EnglishFont_Courier + "')";
            } break;
            case 'EnglishFont_JetBrainsMono':
            case 'GermanFont_JetBrainsMono':
            case 'SpanishFont_JetBrainsMono':
            case 'FrenchFont_JetBrainsMono': {
                fontUrlLocal = "url('" + EnglishFont_JetBrainsMono + "')";
            } break;
            case 'EnglishFont_Arial':
            case 'GermanFont_Arial':
            case 'SpanishFont_Arial':
            case 'FrenchFont_Arial': {
                fontUrlLocal = "url('" + EnglishFont_Arial + "')";
            } break;
            case 'EnglishFont_Tahoma':
            case 'GermanFont_Tahoma':
            case 'SpanishFont_Tahoma':
            case 'FrenchFont_Tahoma': {
                fontUrlLocal = "url('" + EnglishFont_Tahoma + "')";
            } break;
            case 'EnglishFont_Verdana':
            case 'GermanFont_Verdana':
            case 'SpanishFont_Verdana':
            case 'FrenchFont_Verdana': {
                fontUrlLocal = "url('" + EnglishFont_Verdana + "')";
            } break;
            default: {
                fontUrlLocal = "url('" + EnglishFont + "')";
            } break;
        }

        if (fontUrlLocal) {
            while (content.indexOf(toReplace) > -1) {
                content = content.replace(toReplace, fontUrlLocal);
            }
        }
    }

    return content;
}